import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoSlashDateFormat]',
  standalone: true
})
export class AutoSlashDateFormatDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(): void {
    const input = this.el.nativeElement;
    const cursorPosition = input.selectionStart;
    const currentValue = input.value;

    // Count digits before cursor in the current input
    const beforeCursor = currentValue.substring(0, cursorPosition);
    const digitsBeforeCursor = beforeCursor.replace(/\D/g, '').length;

    // Extract all digits from the input
    const digitsOnly = currentValue.replace(/\D/g, '');

    // Build formatted value based on digits only
    let formattedValue = '';
    const maxLength = 8; // MMDDYYYY

    // Limit to max 8 digits
    const digits = digitsOnly.substring(0, maxLength);

    if (digits.length <= 2) {
      // Only month: MM
      formattedValue = digits;
    } else if (digits.length <= 4) {
      // Month and day: MM/DD
      formattedValue = digits.substring(0, 2) + '/' + digits.substring(2);
    } else {
      // Month, day, and year: MM/DD/YYYY
      formattedValue = digits.substring(0, 2) + '/' +
                       digits.substring(2, 4) + '/' +
                       digits.substring(4);
    }

    // Update input value
    input.value = formattedValue;

    // Calculate new cursor position based on digit count
    let newCursorPosition = 0;
    let digitCount = 0;

    // Find position in formatted string where we have counted the same number of digits
    for (let i = 0; i < formattedValue.length && digitCount < digitsBeforeCursor; i++) {
      if (/\d/.test(formattedValue[i])) {
        digitCount++;
      }
      newCursorPosition = i + 1;
    }

    // If cursor is at the end, place it at the very end
    if (digitsBeforeCursor >= digits.length) {
      newCursorPosition = formattedValue.length;
    }

    // Restore cursor position
    input.setSelectionRange(newCursorPosition, newCursorPosition);
  }
}
